export const DEFAULT_SIDEBAR_Z_INDEX = 1035;
